import { apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmInspectorType } from '../interfaces/IKnmInspectorType';

export async function fetchKnmInspectorTypes(): Promise<IKnmInspectorType[]> {
  return apiGet<IKnmInspectorType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-inspector-types`);
}

export async function createKnmInspectorType(knmInspectorType: Omit<IKnmInspectorType, 'id'>): Promise<void> {
  return apiPost({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-inspector-types`,
    body: knmInspectorType,
  });
}

export async function updateKnmInspectorType(knmInspectorType: IKnmInspectorType): Promise<void> {
  const { id, ...data } = knmInspectorType;

  return apiPut(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-inspector-types/${id}`, data);
}
